/* TreeNode: use to create tree structure for va & vw tests */
export class TreeNode {
  constructor(value) {
    this.id = value.id;
    this.value = value;
    this.descendants = [];
    this.parent = null;
    this.level = null; // level of current treeNode in trees(root: 0, root.parent: 1, root.parent.parent: 2)
  }
}